export default __webpack_public_path__ + "static/flag-gb-9acbd7bb34a7a292659e7b243ffa90e9.svg";